import { actionTypes } from "../actions/meetings";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_MEETINGS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;